module.exports = __webpack_public_path__ + "assets/img/submitBtn_all_marketing.ba22a626.png";